import React, { useRef } from "react";
import CardSlider from "./CardSlider";
import { SwiperSlide } from "swiper/react";
import Card from "../Card";
import NavigationButton from "./SliderBtn";

const MentorSlider = ({ data }) => {
  const swiperRef = useRef(null);

  return (
    <div>
      {" "}
      
      <CardSlider onSwiper={(swiper) => (swiperRef.current = swiper)}>
        {data.map((card, index) => {
          return (
            <SwiperSlide key={index} style={{ width: "fit-content" }}>
              <Card
                image={card.image}
                location={card.location}
                university={card.university}
                department={card.department}
                name={card.name}
                designation={card.profession}
                title={card.title}
              />
            </SwiperSlide>
          );
        })}
           
      </CardSlider>
      {data.length >= 4 && (
        <div>
          <NavigationButton swiperRef={swiperRef} type="prev" />
          <NavigationButton swiperRef={swiperRef} type="right" />
        </div>
      )}
    </div>
  );
};

export default MentorSlider;
